/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const NotificationErrorOutlineFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24">
        <g clipPath="url(#clip0_4301_127)">
          <path
            d="M0 12C5.79387e-07 5.37258 5.37258 -5.79387e-07 12 0C18.6274 5.79387e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 -5.79387e-07 18.6274 0 12ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path d="M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7V13Z" />
          <path d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z" />
        </g>
        <defs>
          <clipPath id="clip0_4301_127">
            <rect width="24" height="24" />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  );
});

export { NotificationErrorOutlineFillIcon };
